<template>
  <div>
    <div class="margin-bottom-20 p-relative">
      <Button type="primary" shape="circle" icon="md-arrow-back" @click="to_back_list"></Button><br><br>
      <div class="lease-page">
        <h4>出租方（以下简称“甲方”）： {{ add_params.APartyName }}</h4>
        <h4>开户银行：{{ add_params.APartyBankName }} </h4>
        <h4>账号： {{ add_params.APartyBankNum }}</h4>
        <h4 >承租方（以下简称“乙方”）：<b>{{add_params.BPartyName}}</b><span class="right">（营业执照或身份证号：<b>{{add_params.BPartyNum}}</b>）</span></h4>
        <p class=" clear-both">根据《中华人民共和国合同法》及相关法律、法规之规定，甲乙双方本着“平等自愿、诚实守信”的原则，经友好协商，现就甲方将其房屋租赁给乙方使用的相关事宜达成一致意见，签订本合同，以资双方共同遵守：</p>
        <br>
        <h3 class="text-center">签约说明</h3>
        <h4>第一条  租赁标的</h4>
        <article class="padding-l20">
          <p> 1、租赁标的：位于成都市 <b>{{add_params.Address}}</b> 的商业用房。</p>
          <p> 2、租赁物建筑面积： <b>{{add_params.Area}}</b>平方米。</p>
        </article>
        <h4> 第二条  租赁用途</h4>
        <article class="padding-l20">
          <p>乙方承租租赁物的用途及经营范围： {{add_params.BusinessScope}}</p>
        </article>
        <h4>第三条  租赁期限和优先权</h4>
        <article class="padding-l20">
          <p >1、双方约定租赁期限为 <b>{{add_params.TimeUnit}}</b> 月，从 <b>{{add_params.BeginDate}}</b> 至 <b>{{add_params.EndDate}}</b> 。</p>
          <p>2、租赁限期届满时，甲方如仍愿继续出租租赁物，在同等条件下，乙方有优先租赁权，但乙方须提前两个月向甲方提出续租要求。乙方未提出续租要求的，租赁期限届满之日起三天内，腾退租赁房屋；乙方未按时腾退租赁房屋的，甲方有权按租赁合同届满时租赁费用的两倍收取乙方实际使用费；逾期超过10天乙方仍未腾退租赁房屋的，甲方除按实际天数收取乙方两倍实际使用费外，视为乙方放弃租赁房屋内物品的所有权，甲方有权自行处理，乙方不得有任何异议。</p>
          <p>3、乙方在租赁期内如改变使用用途或转租，应事前征得甲方书面同意，未经书面同意，乙方不得擅自改变用途或转租、转让、转借。</p>
        </article>
        <h4>第四条   租赁费用和其他费用及给付</h4>
        <article class="padding-l20">
          <p>1、租赁费用</p>
          <div class="padding-l20">
            <p>（1）租赁物建筑面积：{{add_params.AreaRent}}平方米。</p>
            <p>（2）租赁费用：</p>
            <div class="padding-l34">
              <div class="user_info_group">
                <div v-for="(item,index) in add_params.PriceDetailList" :key="index">
                  <div style="margin-bottom: 15px;"><span style="color: #333">
                    第{{other_modify(index+1)}}个租赁年度（
                    <b >{{ item.BeginDate }}</b>
                    -
                    <b >{{ item.EndDate }}</b>
                    ）
                  </span>
                    <label style="color: #333" v-if="index!=0">，
                      比上一年度递增
                      <span >{{item.YearPercent}}</span>%</label>
                    <div v-for="(child,cindex) in item.DetailList" :key="cindex" style="margin-top: 5px;">
                      每月{{ child.Type }}费用&nbsp;¥<b>{{child.MonthPrice}}</b>&nbsp;元，
                      <span>租赁单价&nbsp;¥<b >{{child.MeterPrice}}</b>&nbsp;元/<i v-html="child.Type=='车位租金'?'个':'㎡'"></i>/月</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <p>（3）租赁费用中所含的管理费与乙方向管理该租赁物所处小区的物业服务公司缴纳的物业管理费不是同一费用。 </p>
            <p>（4）合同签订后三个工作日内，
              <br>乙方应交付甲方履约保证金：¥<b>{{add_params.AgreeDeposit}}</b>元（大写人民币：{{ DX(add_params.AgreeDeposit) }}）。
              <br>水电保证金：¥<b>{{add_params.WaterDeposit}}</b>元（大写人民币：{{ DX(add_params.WaterDeposit) }}），
              <br>以上保证金至本合同履行完毕，乙方凭甲方开具的收款收据甲方于三个工作日内退还乙方（无息），无收款收据甲方有权不予退还保证金。若乙方违约应承担的违约金，甲方有权将乙方所交保证金扣抵，乙方应于甲方扣抵通知之日起5天内补足保证金。</p>
            <p>（5）租赁费用给付：合同签订后三个工作日内，
              <br>乙方应按本合同甲方指定银行账户支付 <b>{{d_payType}} </b>的租赁费用¥  <b>{{add_params.FirstQuarterRent}}</b>元（大写：{{ DX(add_params.FirstQuarterRent) }}）。以后的租赁费用 {{d_payType}} 给付一次，每次提前15天交纳下 {{d_payType}} 的租赁费用。租赁费用乙方应以转帐形式存入甲方指定银行帐户。甲方并在实际收到租赁费用后三个工作日内给乙方开具发票。
            </p>
          </div>
          <p>2、水、电、通讯、光纤等使用费用由乙方自行承担。具体方式为：电费按商业标准执行，水费按商业标准执行（特种用水按相应收费标准执行）。甲方提供给乙方达到商业清水房基本标准，水通、电通的交房条件。</p>
          <p>3、租赁物的内部物业管理由乙方自行负责。</p>
        </article>
      </div>
    </div>
    <!-- <Form ref="formValidate" :model="add_params" :rules="ruleValidate" :label-width="100">
      <Row>

        <FormItem label="合同名称" prop="Name">
          <Input v-model="add_params.Name" placeholder="请输入合同名称"></Input>
        </FormItem>
        <FormItem label="经办人" prop="Agent">
          <Input v-model="add_params.Agent" placeholder="请输入经办人"></Input>
        </FormItem>
        <FormItem label="备注" prop="Notes">
          <Input v-model="add_params.Notes" type="textarea" placeholder="请输入备注" />
        </FormItem>
        <FormItem label="合同附件" prop="photos1" style="height: auto;">
          <Upload
            ref="IDImgList"
            :default-file-list="d_defaultList_ID"
            :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=contract&&type=合同附件'"
             multiple
            :headers="{Authorization:token}"
            :on-preview="img_preview"
            :on-format-error="file_format_error">
            <Button icon="ios-cloud-upload-outline">请选择文件</Button>
          </Upload>
        </FormItem>
        <FormItem label="审批附件" prop="photos2" style="height: auto;">
          <Upload
            ref="businessImgList"
            :default-file-list="d_defaultList_business"
            :action="$store.state.app.baseUrl + '/api/Pub/UploadFile?outType=contract&&type=审批附件'"
            multiple
            :headers="{Authorization:token}"
            :on-format-error="file_format_error"
            :on-preview="img_preview">
            <Button icon="ios-cloud-upload-outline">请选择文件</Button>
          </Upload>
           <p class="tip-p">允许上传的格式：'jpg','jpeg','png','pdf','bmp'。</p>-->
        <!-- </FormItem>
        <FormItem label="签订日期" prop="SignDate">
          <DatePicker :value="add_params.SignDate" type="date" placeholder="请选择签订日期"  @on-change="change_date_sign"></DatePicker>
        </FormItem>

      </Row> -->
    <!-- </Form> -->
    <div class="detail-group clear-both">
        <section><label>合同名称：</label><span>{{ add_params.Name }}</span></section>
        <section><label>经办人：</label><span>{{ add_params.Agent }}</span></section>
        <section><label>备注：</label><span>{{ add_params.Notes }}</span></section>
        <section><label>状态(是否关闭)：</label><span>{{ add_params.State }}</span></section>
        <section style="display:flex;"><label>合同附件：</label>
        <div><a style="display:block;" v-for="(item,index) in d_defaultList_ID" :key="index" @click="img_preview(item)"> {{ item.name }} </a>
       </div>
         </section>
        <section style="display:flex;"><label>审批附件：</label>
        <div>
           <a style="display:block;" v-for="(item,index) in d_defaultList_business" :key="index" @click="img_preview(item)"> {{ item.name }} </a>
        </div>
        </section>
        <section><label>签订日期：</label><span> {{ add_params.SignDate }}</span></section>
      </div>
    <Modal title="图片预览" v-model="d_img_visible" @on-cancel="cancel_preview" footer-hide>
      <img :src="d_img_name" v-if="d_img_visible" style="width: 100%">
    </Modal>
  </div>
</template>
<script>
  import apiContract from '../../api/contract.js';
  import apiPublic from '../../api/public.js';
  import mixin from '@/components/common/mixin.js';
  export default {
    name:'leaseDetail_page',
    mixins: [mixin],
    data() {
      return {
        add_params:{},
        d_detail_id:'',
        d_defaultList_ID:[],
        d_defaultList_business:[],
        d_img_visible: false,
        d_img_name:'',
        d_payType:'',
        d_file1:'',
        d_file2:''
      }
    },
    methods:{
      pull_data_edit (){
        let currId = this.d_detail_id;
        apiContract.getEditdto(currId).then((_data) => {
          if(_data.data.ExeSuccess && _data.data.LoginSuccess){
            this.add_params = _data.data.Data;
            this.history_params = JSON.parse(JSON.stringify(_data.data.Data));
            this.d_payType = this.switch_payType2(this.add_params.CycleType);
            let fileList = this.add_params.FileList;
            let defaultListID = [];
            let defaultListBusiness = [];
            for(let i=0;i<fileList.length;i++){
              let thisFile = {};
              thisFile.name = fileList[i].SaveName;
              thisFile.url = fileList[i].SaveName;
              if(fileList[i].Type ==='合同附件'){
                defaultListID.push(thisFile);
              }else if(fileList[i].Type ==='审批附件'){
                defaultListBusiness.push(thisFile);
              }
            }
            this.d_defaultList_ID = defaultListID;
            this.d_defaultList_business = defaultListBusiness;
          }else {
            this.$Message.error(_data.data.Msg);
          }
        });
      },
      DX(n) { // 数字大写
        if (!/^(0|[1-9]\d*)(\.\d+)?$/.test(n))
          return "数据非法";
        var unit = "千百拾亿千百拾万千百拾元角分", str = "";
        n += "00";
        var p = n.indexOf('.');
        if (p >= 0)
          n = n.substring(0, p) + n.substr(p+1, 2);
        unit = unit.substr(unit.length - n.length);
        for (var i=0; i < n.length; i++)
          str += '零壹贰叁肆伍陆柒捌玖'.charAt(n.charAt(i)) + unit.charAt(i);
        return str.replace(/零(千|百|拾|角)/g, "零").replace(/(零)+/g, "零").replace(/零(万|亿|元)/g, "$1").replace(/(亿)万|壹(拾)/g, "$1$2").replace(/^元零?|零分/g, "").replace(/元$/g, "元整");
      },
      to_back_list(){ this.$router.go(-1); },
      other_modify(index){
        switch (index){
          case 1: return '一';break;
          case 2: return '二';break;
          case 3: return '三';break;
          case 4: return '四';break;
          case 5: return '五';break;
          case 6: return '六';break;
          case 7: return '七';break;
          case 8: return '八';break;
          case 9: return '九';break;
          case 10: return '十';break;
          default:
            return index
            break;
        }
      },
      switch_payType2(type){
        switch (type){
          case '月付': return '一个月'; break;
          case '季付': return '三个月'; break;
          case '半年付': return '六个月'; break;
          case '年付': return '十二个月'; break;
          default: return '三个月'; break;
        }
      },
    downFileAll(_name,_data){
      let blob = _data;
      let reader = new FileReader();
      reader.readAsDataURL(blob);
      reader.onload = function (e) {
        let a = document.createElement('a');
        a.download = _name;
        a.href = e.target.result;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      }
    },
      xml_preview(fileName){ // word文档打开
        apiPublic.downLoadFile(fileName).then((_data) => {
          let nameUrl = URL.createObjectURL(_data.data);
          let a = document.createElement('a');
          a.download = '合同附件.xlsx';
          a.href = nameUrl;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
        });
      },
      cancel_preview(){
        window.URL.revokeObjectURL(this.d_img_name);
      },
    },
    created() {
      this.add_params = JSON.parse(JSON.stringify(apiContract.add.data));
      this.d_detail_id = this.$route.params.id;
      this.pull_data_edit();
    }
  }
</script>
<style lang="less" scoped>
  .detail-group{  padding: 20px;background-color: #fff;font-size: 14px; }
  .detail-group section{ margin-bottom: 20px; }
  .detail-group section label{ margin-right: 15px;color: #000c17;min-width: 109px; text-align: right;}
  .detail-group section label,.detail-group section span{ display: inline-block; }
   .tx-user{width: 50px;vertical-align: middle; }
  .lease-page{
    box-sizing: border-box;
    padding: 20px;
    padding-right:80px;
    width: 100%;
    min-height: 980px;
    background-color: #fff;
    font-size: 14px;
   .h-width{ display: inline-block;width: 200px; }
    .page-number{
      padding: 20px;
      text-align: center;
    }
    h4{ clear: both;margin-top: 10px; }
    .user_info_group p{ margin-bottom: 10px;line-height: 30px; }
  }
  .padding-l20{ padding-left: 20px; }
  .padding-l34{ padding-left: 34px; }
  .indent10{ text-indent: 20px; }
  .btn_add{
    position: absolute;
    right: 20px;
  }
  .btn_add_user{ top:129px; }
  .btn_add_shop{ top:267px; }
  .btn_add_list{ top:600px; }
  .type-group{
  .ivu-input-wrapper{ width: 200px;margin-right:10px; }
  }
  i{ font-style: normal }
</style>
